import React, { forwardRef } from 'react';

const PlayIcon = forwardRef((props, ref) => {
  const {
    style: { color },
    ...otherProps
  } = props;

  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width={14}
      height={16}
      viewBox="0 0 14 16"
      fill="none"
      {...otherProps}
    >
      <path
        d="M11.665 5.30803L5.3 0.644033C4.8032 0.281299 4.21573 0.0630804 3.60259 0.0135239C2.98946 -0.0360327 2.37457 0.0850047 1.82596 0.363243C1.27735 0.641481 0.816408 1.06607 0.494145 1.59003C0.171882 2.114 0.000859481 2.7169 7.46059e-07 3.33203V12.665C-0.00041129 13.2807 0.169855 13.8844 0.491886 14.4091C0.813916 14.9338 1.2751 15.359 1.82421 15.6374C2.37333 15.9158 2.98886 16.0365 3.60245 15.9861C4.21603 15.9357 4.80364 15.7162 5.3 15.352L11.665 10.691C12.0871 10.3813 12.4303 9.97662 12.6668 9.50963C12.9034 9.04265 13.0266 8.52652 13.0266 8.00303C13.0266 7.47955 12.9034 6.96342 12.6668 6.49643C12.4303 6.02944 12.0871 5.62472 11.665 5.31503V5.30803Z"
        fill={color}
      />
    </svg>
  );
});

PlayIcon.defaultProps = {
  style: {
    color: 'white',
  },
};

export default PlayIcon;
